export const contactsData = {
    email: 'mdarshadkhan1998@gmail.com',
    phone: '+918431290899 / +917996682110',
    address: 'MD Arshad Khan, SR No 6/6/1/3, Plot No-155A, Lane No 9, Hill View Residency, Khandoba Mal, Lohegaon, Pune, Maharashtra, PIN:- 411047',
    sheetAPI: 'https://docs.google.com/spreadsheets/d/18kiSHjqJSwEoFMJcZE--zACdK40C1s0CRFbwVi5i_d0/edit?usp=sharing'
}